import { createElement, memo } from '@max/max';
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import Image from '@hfe/max-image';
import LinearGradient from '@hfe/max-linear-gradient';
import Button from '@hfe/max-button';
import Sensor from '@max/mbc-sensor';
import NoticeSlider from '../notice-slider';
import LandmarkCard from './landmark-card';
import { RecordTabType } from '../../types/shared';
import { computeProgress, formatProgress } from '../../utils/number';
import { FREE_CARD_AMOUNT } from '../../const';
import { PROGRESS_CARD_ASSET } from './assets';
import './index.scss';
function ExploreProgressV4(props) {
    const { feConfig, hasAssistRecord } = props;
    const { styleConfig } = feConfig ?? {};
    // 主按钮文案 + 引导邀人文案（无助力记录时替换剩余进度文案）均来自运营配置
    const ctaText = feConfig?.onProgressConfig?.btnText || '邀请好友 加速解锁';
    const inviteGuideText = feConfig?.onProgressConfig?.inviteGuideText || '邀好友助力 解锁城市免单卡';
    const rawProgress = computeProgress(props.currentScore, props.totalScore);
    const currentProgress = formatProgress(rawProgress);
    const remainProgress = formatProgress(Math.max(0, 100 - rawProgress));
    const fillWidth = `${Math.max(2, Math.min(100, Math.round(rawProgress)))}%`;
    return <View className="city-explore-progress-v4" style={{
        backgroundColor: styleConfig?.backgroundColor
    }}>
      <LinearGradient colors={[styleConfig?.cardStartColor, styleConfig?.cardEndColor]} start={{
        x: 0,
        y: 0
    }} end={{
        x: 0,
        y: 1
    }} className="city-explore-progress-v4__bg"/>

      <View className="city-explore-progress-v4__content">
        
        <View className="city-explore-progress-v4__header">
          <View className="city-explore-progress-v4__title">
            <Text className="city-explore-progress-v4__title-text" numberOfLines={1}>邀好友攒进度 领</Text>
            <Text className="city-explore-progress-v4__title-amount" numberOfLines={1}>{` ${FREE_CARD_AMOUNT}元`}</Text>
            <Text className="city-explore-progress-v4__title-text" numberOfLines={1}>{`${props.currentCityName}免单卡`}</Text>
          </View>
          <Button className="city-explore-progress-v4__rule" onPress={() => props.onOpenFreeCardRule?.()}>
            <Text className="city-explore-progress-v4__rule-text" numberOfLines={1}>规则</Text>
            <Image className="city-explore-progress-v4__rule-arrow" source={{
        uri: PROGRESS_CARD_ASSET.RULE_ARROW
    }}/>
          </Button>
        </View>

        
        <View className="city-explore-progress-v4__panel">
          <Image className="city-explore-progress-v4__panel-bg" source={{
        uri: PROGRESS_CARD_ASSET.PANEL_BG
    }} resizeMode="cover"/>
          <Image className="city-explore-progress-v4__hand" source={{
        uri: PROGRESS_CARD_ASSET.HAND_BADGE
    }}/>

          
          <View className="city-explore-progress-v4__top-block">
            <View className="city-explore-progress-v4__meter-row">
              
              <View className="city-explore-progress-v4__meter-num-box">
                <Text className="city-explore-progress-v4__meter-num" numberOfLines={1}>{currentProgress}</Text>
              </View>
              <Text className="city-explore-progress-v4__meter-unit" numberOfLines={1}>%</Text>
              
              <Text className="city-explore-progress-v4__meter-sub" numberOfLines={1}>
                {hasAssistRecord ? `再得 ${remainProgress}% 进度即可解锁` : inviteGuideText}
              </Text>
            </View>
            <View className="city-explore-progress-v4__bar">
              
              <LinearGradient colors={['#ff0a35', '#fe2b92']} start={{
        x: 0,
        y: 0
    }} end={{
        x: 1,
        y: 0
    }} className="city-explore-progress-v4__bar-fill" style={{
        width: fillWidth
    }}/>
            </View>
          </View>

          
          <View className="city-explore-progress-v4__actions">
            <Button className="city-explore-progress-v4__entry" onPress={() => props.onChangeTab(RecordTabType.REWARD)}>
              <Image className="city-explore-progress-v4__entry-icon" source={{
        uri: PROGRESS_CARD_ASSET.REWARD_ICON
    }}/>
              <Text className="city-explore-progress-v4__entry-text" numberOfLines={1}>看奖励</Text>
            </Button>

            <Button className="city-explore-progress-v4__cta" onPress={() => props.onInviteClick()}>
              <LinearGradient colors={['#ff002a', '#fe2b92']} start={{
        x: 0,
        y: 0
    }} end={{
        x: 1,
        y: 0
    }} className="city-explore-progress-v4__cta-bg"/>
              <Sensor once onAppear={props.onInviteButtonShow}>
                <Text className="city-explore-progress-v4__cta-text" numberOfLines={1}>{ctaText}</Text>
              </Sensor>
            </Button>

            {props.showTaskEntry ? <Sensor once onAppear={() => props.onTaskEntryShow?.()}>
                <Button className="city-explore-progress-v4__entry city-explore-progress-v4__entry--task" onPress={() => props.onOpenTaskModal?.()}>
                  <Image className="city-explore-progress-v4__entry-icon" source={{
        uri: PROGRESS_CARD_ASSET.TASK_ICON
    }}/>
                  <Text className="city-explore-progress-v4__entry-text" numberOfLines={1}>做任务</Text>
                </Button>
              </Sensor> : null}
          </View>
        </View>

        
        <View className="city-explore-progress-v4__notice">
          <NoticeSlider items={props.noticeItems} containerStyle={{
        height: '36rpx'
    }}/>
        </View>

        
        <View className="city-explore-progress-v4__landmark-section">
          <Image className="city-explore-progress-v4__landmark-header" source={{
        uri: PROGRESS_CARD_ASSET.LANDMARK_HEADER
    }} resizeMode="contain"/>
          <View className="city-explore-progress-v4__landmark-row">
            {props.landmarks.map(landmark => <LandmarkCard key={landmark.cardId} landmark={landmark} onOpenLandmark={props.onOpenLandmark}/>)}
          </View>
        </View>
      </View>
    </View>;
}
export default memo(ExploreProgressV4);
